import { Injectable } from '@angular/core';
import { DefaultDataServiceConfig, Logger } from '@ngrx/data';
import { HttpClient } from '@angular/common/http';
import {AbstractDataServiceV2} from '../../../../../core/service/v2/dataservice/abstractDataServiceV2';
import {CustomizeHttpUrlGenerator} from '../../../../../../store/core/url/customizeHttpUrlGenerator';
import {InsolesModelModel} from "../../../api/entity/insolesModel.model";
import {InsolesModelConverter} from "../../../api/entity/insolesModel.converter";

@Injectable()
export class InsolesModelDataService extends AbstractDataServiceV2<InsolesModelModel, InsolesModelConverter> {
    constructor(
        http: HttpClient,
        httpUrlGenerator: CustomizeHttpUrlGenerator,
        logger: Logger,
        config: DefaultDataServiceConfig,
        converter: InsolesModelConverter) {
        super('InsolesModel', http, httpUrlGenerator, logger, config, converter);
    }
}
